module.exports = __webpack_public_path__ + "static/img/item04.e5db15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item04.png
// module id = pWXj
// module chunks = 0